import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'hm.theme';

/// Read once on mount, but ALSO keep the DOM class in sync whenever the
/// state changes. Used by every top-level route (App, Browse, Designer,
/// Profile, CustomPuzzlePlay) so the toggle in the header behaves the
/// same everywhere.
function loadTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function useTheme(): { theme: Theme; toggle: () => void; setTheme: (t: Theme) => void } {
  const [theme, setTheme] = useState<Theme>(loadTheme);
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* ignore */ }
  }, [theme]);
  return {
    theme,
    setTheme,
    toggle: () => setTheme(t => t === 'dark' ? 'light' : 'dark'),
  };
}
